import { UserModel } from '../models/user.model';
import { SiteModel } from '../models/site.model';
import { AuditItemModel } from '../audit-items/audit-item.model';
import { IncidentCauseModel } from '../incidents/incident-cause.model';
import { Auditable } from '../shared/auditable.model';
import { FileModel } from '../shared/file.model';
import { AssetModel } from '../models/asset.model';

export class ActionModel extends Auditable {
  id: number;
  name: string;
  type: 'Corrective Action' |
  'Compliance & Regulatory Inspections' |
  'Contractor Management & Performance' |
  'Cybersecurity & Data Protection' |
  'Electrical Systems' |
  'Emergency Exits & Evacuation Routes' |
  'Environmental Management' |
  'Ergonomics & Manual Handling' |
  'Explosive Handling & Storage' |
  'Fire Safety Equipment' |
  'Food Safety & Hygiene' |
  'General Maintenance' |
  'Hazardous Materials Handling' |
  'Housekeeping & Cleanliness' |
  'HVAC & Ventilation' |
  'Induction & Onboarding' |
  'Incident Investigation' |
  'Inspections & Audits' |
  'Lighting (General & Emergency)' |
  'Machinery & Equipment Safety' |
  'Maintenance & Repairs' |
  'Noise & Vibration Hazards' |
  'Pest Control' |
  'Plumbing & Water Systems' |
  'Procedure & Policy Updates' |
  'Production & Quality Control' |
  'Safety Barriers & Guarding' |
  'Safety Equipment Checks' |
  'Security Systems & Access Control' |
  'Signage & Labelling' |
  'Site & Logistics Preparation' |
  'Structural Integrity' |
  'Training & Competency' |
  'Vehicle & Traffic Management' |
  'Working at Heights' |
  'Other';

  origin: 'Internal Audits / Inspections' |
    'External Audits / Regulatory Inspections' |
    'Accidents / Notifiable Events' |
    'Hazard / Near Miss Reporting' |
    'Risk Assessments' |
    'Equipment / Maintenance' |
    'Management of Change (MOC)' |
    'Emergency Preparedness / Drills' |
    'Management Review Meetings' |
    'Worker Participation / HSR Feedback' |
    'Customer / Client Complaints' |
    'Non-Conformance Reports' |
    'Continuous Improvement Initiatives' |
    'Task' |
    'Other / General' |
    // System-generated origins (set by the backend when a task is auto-created
    // from another feature). These mirror UtilsService.getActionSystemOrigins().
    'Asset' |
    'Inspection & Audit' |
    'Incident' |
    'Safety Observation' |
    'Toolbox Talk';

  description: string;
  priority: 'Medium' | 'High' | 'Critical' | 'Low';
  due: string;
  completed: boolean;
  users: UserModel[];
  user_ids?: number[];
  incident_cause_id: number;
  new_files?: FileList;

  group_id?: number;

  audit_items?: AuditItemModel[];

  incident_cause?: IncidentCauseModel;

  files?: FileModel[] = [];

  // This is used when multiple tasks are created in one go and assigned to different users. Each task will have its own set of files uploaded.
  related_action_ids: number[] = [];

  /**
   * Should this action be shared amongst users or be created multiple times
   * for each user?
   */
  individual_actions?: boolean;

  /**
   * Used for assigning and updating the Site.
   */
  site_id?: number;

  /**
   * Returned when getting the site of an Action.
   */
  site: SiteModel;

  /**
   * Who created this Action?
   */
  creator: UserModel;

  /**
   * Who last updated this Action?
   */
  updater: UserModel;

  /**
   * This is not stored in the actions table. It is simply passed along with the form data
   * to associate the action with the given safety observation.
   */
  safety_observation_id: number;

  /**
   * This is not stored in the actions table. It is simply passed along with the form data
   * to associate the action with the given toolbox talk.
   */
  toolbox_talk_id: number;

  /**
   * This is not stored in the actions table. It is simply passed along with the form data
   * to associate the asset with the given task.
   */
  asset_id?: number;

  /**
   * Returned when an action originated from an asset. The linked asset(s) via the
   * action_assets pivot. Used to show and open the originating asset from the task view.
   */
  assets?: AssetModel[];
}
